import React from 'react';

const HorizontalInfoPipe = ({ hasError, style }) => {
    return (
        <div
            id='horizontalInfoPipe'
            style={{
                display: 'grid',
                height: 20,
                minWidth: '50%',
                maxWidth: '85%',
                gridTemplateColumns: '1fr max-content 1fr',
                boxSizing: 'border-box',
                gap: 10,
                ...style
            }}
        >
            <div
                id='leftLine'
                style={{
                    border: `1px solid ${hasError ? '#C40606' : '#414141'}`,
                    borderWidth: '0 0 1px 1px',
                    height: '50%',
                    boxSizing: 'border-box',
                    minWidth: 10
                }}
            />
            <span
                id='oneRequired'
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontFamily: 'roboto',
                    fontSize: 12,
                    color: hasError ? '#C40606' : '#414141',
                    boxSizing: 'border-box',
                    fontWeight: 500
                }}
            >
                {window.translate('One Required')}
            </span>
            <div
                id='rightLine'
                style={{
                    border: `1px solid ${hasError ? '#C40606' : '#414141'}`,
                    borderWidth: '0 1px 1px 0',
                    height: '50%',
                    boxSizing: 'border-box',
                    minWidth: 10
                }}
            />
        </div>
    );
};

export default HorizontalInfoPipe;
